import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faHome,
  faCogs,
  faSignOutAlt,
  faInfoCircle,
  faMinusCircle,
  faSearch,
  faPlus,
  faUsers,
  faCheck,
  faExclamationCircle,
  faChevronRight,
  faUserCircle,
  faUnlockAlt,
  faSave,
  faTimes,
  faEye,
  faEyeSlash,
} from '@fortawesome/free-solid-svg-icons';
import '@cordata/buffet/build/yup';

import '~/styles/manifest.scss';
import { App } from '~/components';
import * as serviceWorker from '~/serviceWorker';
import msalInstance from '~/utils/ms-ad';
import { MsalProvider } from '@azure/msal-react';

library.add(
  faHome,
  faCogs,
  faSignOutAlt,
  faInfoCircle,
  faMinusCircle,
  faSearch,
  faPlus,
  faUsers,
  faCheck,
  faExclamationCircle,
  faChevronRight,
  faUserCircle,
  faUnlockAlt,
  faSave,
  faTimes,
  faEye,
  faEyeSlash,
);

ReactDOM.render(
  <MsalProvider instance={msalInstance}>
    <App />
  </MsalProvider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
